import { render, staticRenderFns } from "./cardioCard.vue?vue&type=template&id=4de08121&scoped=true&"
import script from "./cardioCard.vue?vue&type=script&lang=js&"
export * from "./cardioCard.vue?vue&type=script&lang=js&"
import style0 from "./cardioCard.vue?vue&type=style&index=0&id=4de08121&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de08121",
  null
  
)

export default component.exports